import { getNonBootUserConfigurationSync } from '../getNonBootUserConfiguration';
import type { MailboxInfo } from 'owa-client-types';

export default function isDLPAnnotationsEnabled(mailboxInfo: MailboxInfo): boolean {
    return (
        getNonBootUserConfigurationSync(mailboxInfo, true /* skipAnonymousCheck */)
            ?.CompliantMeetingEnabled ?? false
    );
}
